import React from 'react'
import { Colors } from '../../../theme'

const IconDentist = (props) => {
  const color = props.altcolor === true ? Colors.Palette.whiteColor : Colors.Palette.primaryColor
  return (
    <svg id="Tooth" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192" style={{ height: '-webkit-fill-available' }} width="70" height="70">
      <defs>
        <style>{`.cls-1,.cls-3{fill:none;}.cls-2Dent{fill:${color}}`}</style>
      </defs>
      <title>IconDentist</title>
      <rect className="cls-1" width="192" height="192" />
      <path className="cls-2Dent" d="M172,66c0-24.3-4.7-45-29-45-15.3,0-34.71,3.85-47,12.76C83.71,24.85,64.3,21,49,21,24.7,21,20,41.7,20,66A48.86,48.86,0,0,0,31.91,97.5h0S44,173,64,173s12-56,32-56v0c20,0,12,56,32,56s32.09-75.5,32.09-75.5h0A48.86,48.86,0,0,0,172,66Z" />
    </svg>
  )
}

export default IconDentist



// WEBPACK FOOTER //
// ./src/assets/images/svg/Icon-Dentist.js